import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 1,
      "name": "sk.svg",
      "url": "https://apiweb.smako.sk/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 2,
    "name": "Český jazyk",
    "locale": "cs",
    "image": {
      "id": 2,
      "name": "cz.svg",
      "url": "https://apiweb.smako.sk/files/cz.svg?ai=0",
      "custom_title": "cz",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
